export default __webpack_public_path__ + "static/assets/med_pill_square_flat_L2_solid_l_01_f.aafa548f.png";